module.exports = __webpack_public_path__ + "static/media/undraw_refreshing_beverage_td3r 1.cd1d0412.svg";